import { render, staticRenderFns } from "./VideosPage.vue?vue&type=template&id=0d4e3d98&scoped=true&lang=pug"
import script from "./VideosPage.vue?vue&type=script&lang=js"
export * from "./VideosPage.vue?vue&type=script&lang=js"
import style0 from "./VideosPage.vue?vue&type=style&index=0&id=0d4e3d98&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4e3d98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d4e3d98')) {
      api.createRecord('0d4e3d98', component.options)
    } else {
      api.reload('0d4e3d98', component.options)
    }
    module.hot.accept("./VideosPage.vue?vue&type=template&id=0d4e3d98&scoped=true&lang=pug", function () {
      api.rerender('0d4e3d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/help_center/VideosPage.vue"
export default component.exports